module.exports = __webpack_public_path__ + "static/media/battery.23864c7a.svg";